import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import jobHourIcon from "assets/images/job-hour.svg";
import jobLinkIcon from "assets/images/job-link.svg";
import DataBox from "./DataBox";

function HourlyRate({
  t,
  staffDetails,
  selectedReview,
  officeId,
  hourlyView,
  linkView,
  hideShow,
}) {
  return (
    <>
      {staffDetails && (
        <>
          {hourlyView && (
            <DataBox
              icon={jobHourIcon}
              label={t("staff.hourlyRate")}
              directChild
            >
              <h4>
                {staffDetails.hourlyRate
                  ? (hideShow ? staffDetails.hourlyRate.toFixed(2) : "XX") +
                    " " +
                    t("superAdmin.cad")
                  : "--"}
              </h4>
              {staffDetails.staffMemberId && hideShow ? (
                <Link
                  to={{
                    pathname: constants.routes.staff.hourlyRate,
                    state: {
                      detail: staffDetails,
                      OfficeId: officeId,
                    },
                  }}
                >
                  <span className="link-btn mb-3">{t("staff.seeHistory")}</span>
                </Link>
              ) : null}
            </DataBox>
          )}
          {linkView && (
            <DataBox
              icon={jobLinkIcon}
              label={t("staff.linkedPerformanceReview")}
              parentClass={linkView}
            >
              {selectedReview ? selectedReview : t("staff.noReviews")}
            </DataBox>
          )}
        </>
      )}
    </>
  );
}

export default withTranslation()(HourlyRate);
